import React from "react";

const Modal = ({ children, show }) => {
  if (!show) return;
  return (
    <div
      className={`fixed ${
        show ? "block" : "hidden"
      } inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full`}
      id="my-modal"
    >
      <div className="relative top-20 mx-auto border w-3/5 shadow-lg rounded-2xl bg-white">
        {children}
      </div>
    </div>
  );
};
export default Modal;
